// PROD

const baseURL = "https://dashboard-api.shredmill.com/api/";

const awsConfig = {
  identityPoolId: "<Cognito Identity Pool ID>",
  region: "<Region>",
  userPoolId: "us-east-1_ECH7A6J4c",
  userPoolWebClientId: "mu9g9odsckskr1r0eh2bip4pe",
};

//DEV

// const baseURL = "http://34.204.48.212:8080/api/";
// const baseURL = 'http://52.202.8.44:8080/api/';
// const baseURL = 'https://sqq9189uhb.execute-api.us-east-1.amazonaws.com/api/';


// const baseURL = 'https://u4frqw5fu6.execute-api.us-east-1.amazonaws.com';
//
// const awsConfig = {
//     identityPoolId: "<Cognito Identity Pool ID>",
//     region: "<Region>",
//     userPoolId: "us-east-1_f7abhe1XP",
//     userPoolWebClientId: "5tmrs840jk54t58ctefmp3nscu",
// };

export {awsConfig, baseURL};
